import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ghm_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("ghm_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const handleAuth = (data) => {
    localStorage.setItem("ghm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    return handleAuth(r.data);
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    return handleAuth(r.data);
  };

  const logout = () => {
    localStorage.removeItem("ghm_token");
    setUser(false);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
